import { useContext } from 'react';

import { CurrencyContext } from 'src/contexts';

export const useCurrency = () => useContext(CurrencyContext);
